import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { PaymentCriteria, PaymentProvider } from '../common';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  constructor(private http: HttpClient, private router: Router, private route: ActivatedRoute) { }

  search(criteria: PaymentCriteria, from = 0, limit = 10) {
    return this.http.post<{ payments: any[], total: number }>(environment.app.apiUrl + 'payment/search', { criteria, from, limit }).toPromise();
  }

  get(id: string) {
    return this.http.get<any>(environment.app.apiUrl + 'payment/get/' + id).toPromise();
  }

  changeAmount(id: string, amount: number) {
    return this.http.post<any>(environment.app.apiUrl + 'payment/amount/' + id, amount).toPromise();
  }

  async retry(id: string, changeProvider: boolean, manualToken?: string) {
    const redirect: any = await this.http.get(environment.app.apiUrl + `payment/retry/${id}/${changeProvider}`,
      manualToken ? { params: { 'manual': manualToken } } : {}).toPromise();
    if (redirect.provider == PaymentProvider.Manual)
      this.router.navigateByUrl(location.pathname + '?pid=' + redirect.id)
        .then(() => location.reload());
    else if (redirect.link)
      location.href = redirect.link;
  }

  async verifyManual(paymentId: string, refId: string, succeed?: boolean) {
    const redirect: any = await this.http.get(
      environment.app.apiUrl + `payment/verify-manual/${paymentId}/${refId}/${succeed || 'false'}`
    ).toPromise();
    return redirect.Url;
  }

  remainsKarpasha() {
    return this.http.get<{ remains: number, next: Date }>(environment.app.apiUrl + 'payment/remains/karpasha?_v=1').toPromise();
  }
}
